import React from 'react';
import { Tooltip } from 'antd';
import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  MinusCircleOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';

/**
 * "Bu veli ARYS'ye girdi mi?" rozeti.
 *
 * Ödeme masasındaki soru: ödemeye gelen veliye "uygulamayı kullanın" demek
 * gerekiyor mu? Aynı rozet Kullanıcılar listesinde ve öğrenci detayındaki
 * Veliler sekmesinde de var — üçü AYNI kuralı kullansın diye tek bileşen.
 *
 * ÜÇ DURUM VAR, İKİ DEĞİL — ve ortadaki en önemlisi:
 *
 *   yeşil    girdi                   → yapacak bir şey yok
 *   turuncu  aktifleştirdi, girmedi  → şifresini kurmuş ama hiç gelmemiş
 *   kırmızı  hiç aktifleştirmemiş    → üyeliğini hiç kurmamış
 *
 * Aktifleştirme OTOMATİK GİRİŞ YAPMIYOR (ParentActivationController veliye
 * "şimdi giriş yapabilirsiniz" diyor), dolayısıyla turuncu gerçek bir durum.
 * İkisini tek "çarpı"da birleştirmek, hatırlatmanın içeriğini belirsiz
 * bırakırdı: birine "üyeliğinizi aktifleştirin", diğerine "bir uğrayın"
 * denecek.
 */
const DURUMLAR = {
  girdi: {
    icon: <CheckCircleFilled style={{ color: '#52c41a' }} />,
    metin: 'ARYS\'ye giriş yapmış',
  },
  aktif_girmedi: {
    icon: <ExclamationCircleFilled style={{ color: '#fa8c16' }} />,
    metin: 'Üyeliğini aktifleştirmiş ama hiç giriş yapmamış',
  },
  girmedi: {
    icon: <CloseCircleFilled style={{ color: '#ff4d4f' }} />,
    metin: 'ARYS\'ye hiç girmemiş — üyeliğini aktifleştirmesi gerekiyor',
  },
  veli_yok: {
    icon: <MinusCircleOutlined style={{ color: '#bfbfbf' }} />,
    metin: 'Bağlı veli hesabı yok',
  },
};

const durumBul = ({ girdi, aktiflesti }) => {
  if (girdi) return 'girdi';
  return aktiflesti ? 'aktif_girmedi' : 'girmedi';
};

/** Tek bir veli için — Kullanıcılar listesi, öğrenci detayı Veliler sekmesi. */
export function VeliPortalRozeti({ girdi, aktiflesti, lastLoginAt, showText = false }) {
  const key = durumBul({ girdi, aktiflesti });
  const { icon, metin } = DURUMLAR[key];

  const baslik = girdi && lastLoginAt
    ? `${metin} (son giriş: ${dayjs(lastLoginAt).format('DD.MM.YYYY HH:mm')})`
    : metin;

  return (
    <Tooltip title={baslik}>
      <span className="inline-flex items-center gap-1">
        {icon}
        {showText && <span className="text-xs text-gray-500">{metin}</span>}
      </span>
    </Tooltip>
  );
}

/**
 * Bir ÖĞRENCİNİN velileri için toplu rozet — Ödemeler listesi.
 *
 * "En az biri girdi" yeterli sayılıyor: aynı öğrencinin iki velisinden biri
 * uygulamayı kullanıyorsa aile haberdar demektir. Kural backend'deki
 * `VeliPortalDurumu` ile aynı; ikisi ayrışırsa aynı satır iki ekranda farklı
 * renk gösterir.
 */
export function OgrenciVeliPortalRozeti({ veliPortal }) {
  if (!veliPortal) return null;

  const { durum, veliler = [] } = veliPortal;

  if (durum === 'veli_yok') {
    return (
      <Tooltip title={DURUMLAR.veli_yok.metin}>
        <span>{DURUMLAR.veli_yok.icon}</span>
      </Tooltip>
    );
  }

  // Birden fazla veli olabiliyor; hangisinin girdiğini tek tek göstermek
  // "kime hatırlatacağım" sorusunu cevaplıyor.
  const detay = (
    <div>
      {veliler.map((v) => (
        <div key={v.id}>
          {v.ad}: {DURUMLAR[durumBul(v)].metin}
        </div>
      ))}
    </div>
  );

  const key = durum === 'girdi' ? 'girdi' : (
    veliler.some((v) => v.aktiflesti) ? 'aktif_girmedi' : 'girmedi'
  );

  return (
    <Tooltip title={detay}>
      <span>{DURUMLAR[key].icon}</span>
    </Tooltip>
  );
}

export default VeliPortalRozeti;
